import { Action } from '@anm/components/ActionsDropdown';
import { getDropdownAction } from '@anm/helpers/dropdownActions';

import { ActionTooltip } from '@anm/components/dropdown-actions/streamVideo/Wrapper';
import Tooltip from '@anm/components/Tooltip';
import { notStableTooltip } from '@anm/components/dropdown-actions/NotStableTooltip';
import ActionItem from '@anm/components/ActionsDropdown/ActionItem';

type ShareVideoActionProps = {
  handler?: () => void;
  isNotStable?: boolean;
};

const useShareVideoAction = ({ handler, isNotStable }: ShareVideoActionProps) => {
  const action = getDropdownAction('onShare');

  const shareVideoAction: Action = {
    icon: action.icon,
    disabled: isNotStable,
    autoClose: !isNotStable,
    renderComponent: () => (
      <ActionTooltip>
        <Tooltip renderContent={isNotStable ? notStableTooltip : undefined}>
          <ActionItem {...action} handler={handler} />
        </Tooltip>
      </ActionTooltip>
    )
  };

  return shareVideoAction;
};

export default useShareVideoAction;
